const SEARCH_URL = {
  FULL: "Search/index.html",
  FRIENDLY: "e,search.html"
};

export default SEARCH_URL;
